var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { TodoFooter } from './components/TodoFooter';
import { TodoHeader } from './components/TodoHeader';
import { TodoList } from './components/TodoList';
var index = 0;
var TodoApp = /** @class */ (function (_super) {
    __extends(TodoApp, _super);
    function TodoApp(props) {
        var _this = _super.call(this, props) || this;
        _this._addTodo = function (label) {
            var _a;
            var todos = _this.state.todos;
            var id = index++;
            _this.setState({
                todos: __assign({}, todos, (_a = {}, _a[id] = { label: label, completed: false }, _a))
            });
        };
        _this._complete = function (id) {
            var _a;
            var todos = _this.state.todos;
            var todo = todos[id];
            var newTodos = __assign({}, todos, (_a = {}, _a[id] = __assign({}, todo, { completed: !todo.completed }), _a));
            _this.setState({
                todos: newTodos
            });
        };
        _this._clear = function () {
            var todos = _this.state.todos;
            var newTodos = {};
            Object.keys(_this.state.todos).forEach(function (id) {
                if (!todos[id].completed) {
                    newTodos[id] = todos[id];
                }
            });
            _this.setState({
                todos: newTodos
            });
        };
        _this._setFilter = function (filter) {
            _this.setState({
                filter: filter
            });
        };
        _this.state = {
            todos: {},
            filter: 'all'
        };
        return _this;
    }
    TodoApp.prototype.render = function () {
        var _a = this.state, filter = _a.filter, todos = _a.todos;
        return (React.createElement("div", null,
            React.createElement(TodoHeader, { addTodo: this._addTodo, setFilter: this._setFilter, filter: filter }),
            React.createElement(TodoList, { complete: this._complete, todos: todos, filter: filter }),
            React.createElement(TodoFooter, { clear: this._clear, todos: todos })));
    };
    return TodoApp;
}(React.Component));
export { TodoApp };
